var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "choose-content diglog-card",
          attrs: {
            visible: _vm.dialogVisible,
            title: _vm.$t("payment_links.new_link"),
            width: "680px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          _c("div", { staticClass: "section-title" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("payment_links.create_payment_link")) + " "
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "item-container",
              on: { click: _vm.onClickSingleDisbursementBtn },
            },
            [
              _c("el-card", { attrs: { shadow: "hover" } }, [
                _c("div", { staticClass: "item-title" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("payment_links.single_payment_link")) +
                      " "
                  ),
                ]),
                _c("p", { staticClass: "item-content" }, [
                  _vm._v(" " + _vm._s(_vm.$t("payment_links.tip_5")) + " "),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "item-container",
              on: { click: _vm.onClickBatchDisbursementBtn },
            },
            [
              _c("el-card", { attrs: { shadow: "hover" } }, [
                _c("div", { staticClass: "item-title" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("payment_links.batch_payment_link")) +
                      " "
                  ),
                ]),
                _c("p", { staticClass: "item-content" }, [
                  _vm._v(" " + _vm._s(_vm.$t("payment_links.tip_4")) + " "),
                ]),
              ]),
            ],
            1
          ),
        ]
      ),
      _c(
        "BatchPaymentModal",
        _vm._g({ ref: "batchPaymentModal" }, _vm.$listeners)
      ),
      _c(
        "SinglePaymentmentModal",
        _vm._g({ ref: "singlePaymentModal" }, _vm.$listeners)
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }